
import { RefCodeEntityDecoratorBase } from './ref-code.decorator.base';


export class RefCodeEntityDecorator extends RefCodeEntityDecoratorBase {
  constructor() {
    super();
  }
}



